import { readFileSync } from "node:fs";
import { dirname, join } from "node:path";
import { fileURLToPath } from "node:url";
import type { ChatMessage, TaskContextDTO } from "@project/shared";

export function mapChatHistory(
  messages: TaskContextDTO["chatHistory"] | undefined | null,
): ChatMessage[] {
  if (!messages) return [];
  return messages.map((m) => ({
    id: m.id,
    role: (m.role ?? "user") as "user" | "assistant" | "system",
    content: m.content ?? "",
    userId: m.userId,
    userName: m.user?.name ?? undefined,
    createdAt: m.createdAt,
    ...(m.files && m.files.length > 0
      ? {
          files: m.files.map((f) => ({
            fileId: f.id,
            fileName: f.fileName,
            mimeType: f.mimeType,
            fileSize: f.fileSize,
            downloadUrl: f.downloadUrl ?? "",
            content: f.content,
            contentEncoding: f.contentEncoding,
          })),
        }
      : {}),
  }));
}

/** Read this agent's version from its bundled package.json. */
export function readAgentVersion(): string | null {
  try {
    const here = dirname(fileURLToPath(import.meta.url));
    // Walk up: dist/runner/session-runner.js → dist/ → package.json
    for (const rel of ["../package.json", "../../package.json"]) {
      try {
        const pkg = JSON.parse(readFileSync(join(here, rel), "utf-8")) as { version?: string };
        if (pkg.version) return pkg.version;
      } catch {
        /* try next candidate */
      }
    }
  } catch {
    /* ignore */
  }
  return null;
}
